import MainDictionary from "../components/dictionary/MainDictionary";

function Diccionario() {
    return ( <MainDictionary/> );
}

export default Diccionario;